import { IconButtonProps, styled } from "@mui/material";
import { GridActionsCellItem as GridActionsCellItemBase } from "@mui/x-data-grid";
import { GridActionsCellItemProps } from "@mui/x-data-grid-pro";

// @ts-ignore for some reason, GridActionsCellItem is no accepted to style
export const GridActionsCellItem = styled(GridActionsCellItemBase)<
  Omit<GridActionsCellItemProps, "color"> & { color: IconButtonProps["color"] }
>(({ color, theme }) => ({
  color: theme.palette.action.active,
  "&:hover": {
    color: color && color !== "inherit" && color !== "default" && theme.palette[color]?.main,
  },
}));
